// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {Field, reduxForm} from 'redux-form'
import {FormGroup, InputField} from '../../form'
import classnames from 'classnames'
import {login} from '../../../actions/user'
import {NavLink} from 'react-router-dom'

import './loginForm.css'
import {VerimatrixLogo} from '../../../media/exports'

import ErrorIcon from '@material-ui/icons/Error'

class LoginForm extends Component {
  render () {
    const {error, handleSubmit, submitting, invalid} = this.props
    return (
      <div className='col-lg-4 col-md-6 col-7'>
        <form className={classnames('form login-form', {error})} onSubmit={handleSubmit}>
          {<img src={VerimatrixLogo} alt='Verimatrix Logo' className='vmx-logo'/>}
          <div className='login-fields container'>
            <div className='inputs'>
              <FormGroup className='row'>
                <div className='col-12'>
                  <label>Username</label>
                </div>
                <div className='col-12'>
                  <Field
                    name='username'
                    type='email'
                    placeholder='Enter email address'
                    component={InputField}
                  />
                </div>
              </FormGroup>
              <FormGroup className='row'>
                <div className='col-12'>
                  <label>Password</label>
                </div>
                <div className='col-12'>
                  <Field
                    name='password'
                    type='password'
                    placeholder='Enter temporary or permanent password'
                    component={InputField}
                  />
                </div>
              </FormGroup>
            </div>
            <div className='error row col-12'>
              {error &&
              <><ErrorIcon/>{error}</>
              }
            </div>
            <FormGroup className='row buttons'>
              <div className='col-6'>
                <button className='btn btn-accept' type='submit' disabled={submitting || invalid}>Sign In</button>
              </div>
              <div className='col-6'>
                <NavLink className='btn btn-cancel' to={`/reset-password/`}>Reset Password</NavLink>
              </div>
            </FormGroup>
          </div>
        </form>
      </div>
    )
  }
}

function onSubmit (values, dispatch) {
  dispatch(login(values))
}

export function validate (values) {
  let ret = {}
  if (!values.username || !values.username.trim()) {
    ret = {...ret, username: 'Username cannot be blank'}
  }
  if (!values.password || !values.password.trim()) {
    ret = {...ret, password: 'Password cannot be blank'}
  }
  return ret
}

export default reduxForm({
  // a unique name for the form
  form: 'login',
  onSubmit: onSubmit,
  validate: validate
})(LoginForm)
